import { render, staticRenderFns } from "./aboutCenFzls.vue?vue&type=template&id=41982197&scoped=true&"
import script from "./aboutCenFzls.vue?vue&type=script&lang=js&"
export * from "./aboutCenFzls.vue?vue&type=script&lang=js&"
import style0 from "./aboutCenFzls.vue?vue&type=style&index=0&lang=css&"
import style1 from "./aboutCenFzls.vue?vue&type=style&index=1&id=41982197&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41982197",
  null
  
)

export default component.exports